import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
axios.interceptors.request.use(
	async function (req) {
		let temp = await localStorage.getItem("token");
		if (temp) {
			temp = JSON.parse(temp);
			if (temp) {
				req.headers["Authorization"] = `Bearer ${temp}`;
			}
		}
		return req;
	},
	function (error) {
		return Promise.reject(error);
	}
);
axios.interceptors.response.use(
	function (res) {
		return res;
	},
	async function (error) {
		let temp = await localStorage.getItem("token");
		temp = temp ? JSON.parse(temp) : null;

		if (temp && error?.response?.status === 401) {
			localStorage.removeItem("token");
			window.location.href = "/";
		} else {
			return Promise.reject(error);
		}
	}
);

const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate;
renderMethod(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
